import React, { useState, useMemo, useEffect, useCallback } from 'react';
import CardAPagar from '../Financeiro/CardParcela/APagar';
import CardPaga from '../Financeiro/CardParcela/Pagas';
import ResumoBoletosPendentes from '../Financeiro/CardParcela/ResumoBoletosPendentes';
import CardSolicitacao from '../Solicitacoes/TodasSolicitacoes/CardSolicitacao';
import CardSolicitacaoMobile from '../Solicitacoes/TodasSolicitacoes/CardSolicitacaoMobile';
import FooterAlertas from './FooterAlertas';
import FiltrosSolicitacoes from '../Solicitacoes/TodasSolicitacoes/FiltrosSolicitacoes';
import Pagination from '../../Components/Pagination';

import useWindowDimension from '../../hooks/WindowDimension';
import { PaginacaoContainer } from './styles';
import HeaderSolicitacao from '../Solicitacoes/TodasSolicitacoes/Header';
import HeaderSolicitacaoMobile from '../Solicitacoes/TodasSolicitacoes/HeaderMobile';
import './styles.scss';

const Paginacao = ({
  parcelas,
  setParcelasSelecionadas,
  parcelasSelecionadas,
  tema,
  tipo,
  codOcorrencia,
  parcelasAPagar,
  setSolicitacaoInvalida,
  setFiltroPorStatus,
  filtroPorStatus,
  simulacaoRenegociacao,
  simulador,
  desabilitarBtnSelecionarParcela,
  hideFiltros,
  isSindico,
  contratoSelecionado,
}) => {
  let pageSize = tipo === 'aPagar' ? 5 : 10;
  const dimensions = useWindowDimension();
  const [page, setPage] = useState(1);

  const [btnAtivoMaisDetalhes, setBtnAtivoMaisDetalhes] = useState('');

  const currentTableData = useMemo(() => {
    const firstPageIndex = (page - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return (
      parcelas.length > 0 && parcelas?.slice(firstPageIndex, lastPageIndex)
    );
  }, [page, parcelas]);

  useEffect(() => {
    setPage(1);
  }, [filtroPorStatus]);

  const handlePageChange = useCallback((page) => setPage(page), []);

  const billElements =
    currentTableData.length > 0 &&
    currentTableData?.map((b, index) => {
      if (tipo == 'solicitacoes') {
        if (dimensions.winWidth > 1000) {
          return (
            <CardSolicitacao
              key={index}
              item={b}
              isSindico={isSindico}
            ></CardSolicitacao>
          );
        } else {
          return (
            <CardSolicitacaoMobile
              key={index}
              item={b}
              isSindico={isSindico}
            ></CardSolicitacaoMobile>
          );
        }
      } else if (tipo == 'aPagar') {
        return (
          <React.Fragment key={index}>
            <CardAPagar
              simulador={simulador}
              parcela={b}
              setParcelasSelecionadas={setParcelasSelecionadas}
              parcelasSelecionadas={parcelasSelecionadas}
              tema={tema}
              index={b.idReceber}
              codOcorrencia={codOcorrencia}
              parcelasAPagar={parcelasAPagar}
              setSolicitacaoInvalida={setSolicitacaoInvalida}
              simulacaoRenegociacao={simulacaoRenegociacao}
              desabilitarBtnSelecionarParcela={desabilitarBtnSelecionarParcela}
            />
          </React.Fragment>
        );
      } else if (tipo == 'boletosPendentes') {
        return (
          <React.Fragment key={index}>
            <ResumoBoletosPendentes
              parcelas={b}
              index={b.numeroParcelaGeral + b.numeroParcela}
              tema={tema}
              setSolicitacaoInvalida={setSolicitacaoInvalida}
              contratoSelecionado={contratoSelecionado}
            />
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={index}>
            <CardPaga
              parcela={b}
              tema={tema}
              index={index + b.numeroParcela}
              btnAtivoMaisDetalhes={btnAtivoMaisDetalhes}
              setBtnAtivoMaisDetalhes={setBtnAtivoMaisDetalhes}
            />
          </React.Fragment>
        );
      }
    });

  return (
    <>
      {tipo === 'solicitacoes' && dimensions.winWidth > 1000 && (
        <HeaderSolicitacao />
      )}
      {tipo === 'solicitacoes' && dimensions.winWidth < 1000 && (
        <HeaderSolicitacaoMobile />
      )}

      <PaginacaoContainer tipo={tipo}>
        {tipo === 'solicitacoes' && parcelas?.length === 0 && (
          <p>Não há registros para exibir do tipo {filtroPorStatus[0]}</p>
        )}
        {parcelas?.length > 0 && billElements}
      </PaginacaoContainer>

      <div className='centralized-column footerFinanceiro'>
        <div
          className={
            tipo === 'solicitacoes' ? ' footerPaginacaoSolicitacoes' : ''
          }
          style={{ width: '100%' }}
        >
          {tipo == 'solicitacoes' && !hideFiltros && (
            <FiltrosSolicitacoes
              tema={tema}
              setFiltroPorStatus={setFiltroPorStatus}
              filtroPorStatus={filtroPorStatus}
            />
          )}
          {((tipo === 'solicitacoes' && parcelas?.length > 0) ||
            tipo != 'solicitacoes') && (
            <Pagination
              tema={tema}
              currentPage={page}
              onPageChange={handlePageChange}
              totalCount={parcelas.length}
              pageSize={pageSize}
            ></Pagination>
          )}
        </div>

        {tipo != 'pagas' && tipo !== 'solicitacoes' && (
          <FooterAlertas tipo={tipo} />
        )}
      </div>
    </>
  );
};

export default Paginacao;
